import { create } from "zustand";
export const useContactsStore = create((set) => ({
  contacts: null,
  setContacts: (contacts) => set({ contacts }),
}));
